import { onError } from '@apollo/client/link/error';
import {
  GRAPHQL_ERROR_CODES,
  GRAPHQL_ERROR_MESSAGES,
} from '../../enums/graphqlErrors';

/**
 * Added only for the anonymous upload-link session (see `all.ts`). A
 * PERMISSION_DENIED carrying the `invalid upload link` message (link disabled or
 * expired) or a NOT_FOUND (link deleted) on any upload-link request — a batch
 * call, OTP, or a metadata refetch — means the link stopped resolving while the
 * visitor was on the page. Reload so the RSC layout re-runs its metadata fetch
 * (`isInvalidUploadLinkError` covers both codes) and renders the unavailable
 * terminal state. This mirrors how `INVALID_SHARE` and
 * `INVALID_UPLOAD_LINK_PASSPHRASE` reload in `ErrorLink`.
 *
 * PERMISSION_DENIED is a generic code used across the app for many reasons, so
 * the reload is gated on the specific `invalid upload link` message the backend
 * sends for a stopped link — otherwise an unrelated permission error mid-session
 * would spuriously reload the uploader. NOT_FOUND stays scoped to this session
 * by the link being added conditionally rather than living in the global
 * `ErrorLink` (which would reload the main app too).
 */
export const uploadLinkUnavailableLink = onError(({ graphQLErrors }) => {
  if (typeof window === 'undefined') return;
  const isUploadLinkUnavailable = graphQLErrors?.some((error) => {
    const code = error?.extensions?.code;
    if (code === GRAPHQL_ERROR_CODES.NOT_FOUND) return true;
    return (
      code === GRAPHQL_ERROR_CODES.PERMISSION_DENIED &&
      error?.message === GRAPHQL_ERROR_MESSAGES.INVALID_UPLOAD_LINK
    );
  });
  if (isUploadLinkUnavailable) window.location.reload();
});
